/**
 * Automatic SCSS Import System
 * This file uses Vite's glob import to automatically import all SCSS files
 * from the component structure, eliminating the need for manual imports in main.scss
 */

// Import core styles first (these need to be loaded in order)
import './core/_fonts.scss';
import './core/_variables.scss';
import './core/_theme.scss';
import './core/_base.scss';
import './core/_grid.scss';
import './core/_utilities.scss';
import '../../views/_page.scss';
import '../../views/_single.scss';

// Global styles
const globalStyles = import.meta.glob([
  '../../views/global/**/*.scss',
], { eager: true });

// Component styles - import in hierarchical order
const atomStyles = import.meta.glob([
  '../../views/components/atoms/**/*.scss',
], { eager: true });

const moleculeStyles = import.meta.glob([
  '../../views/components/molecules/**/*.scss',
], { eager: true });

const organismStyles = import.meta.glob([
  '../../views/components/organisms/**/*.scss',
], { eager: true });

// Dev tools
const devToolStyles = import.meta.glob([
  '../../views/dev-tools/**/*.scss',
], { eager: true });

// Log imported files for debugging (always show during build)
console.log('🎨 SCSS Files Loaded:');
console.log('Global:', Object.keys(globalStyles));
console.log('Atoms:', Object.keys(atomStyles));
console.log('Molecules:', Object.keys(moleculeStyles));
console.log('Organisms:', Object.keys(organismStyles));
console.log('Dev Tools:', Object.keys(devToolStyles));

// Export for potential use in other files
export {
  globalStyles,
  atomStyles,
  moleculeStyles,
  organismStyles,
  devToolStyles
};
